import { Grid } from '@mui/material'
import React, { useCallback } from 'react'
import CalculatePanel, {
    CalculatorSwitchMode,
    IPaymentTypeInfo,
} from '../../CalculationInput/CalculatePanel'
import { PaymentDetail } from '../PaymentDetail'
import Decimal from 'decimal.js'
import { PAYMENT_TYPE_ID } from 'constant/paymentType'
interface IProps {
    onSubmitPayment: () => Promise<string | void>
    quickButtons: number[]
    tipsRate: Decimal
    onSetTipsAmount: (amount: Decimal, mode: CalculatorSwitchMode) => void
    tipsType: CalculatorSwitchMode
    noQuickTip: boolean
    disableSwitchMode?: boolean
}

function AddTipsSection({
    onSubmitPayment,
    quickButtons,
    tipsRate,
    onSetTipsAmount,
    tipsType,
    noQuickTip,
    disableSwitchMode,
}: IProps) {
    const paymentDetail: IPaymentTypeInfo = {
        paymentType: PAYMENT_TYPE_ID.TIPS, // Tips
    }

    const onSwitchCalculator = useCallback(
        (calculatorMode: CalculatorSwitchMode) => {
            onSetTipsAmount(tipsRate, calculatorMode)
        },
        [onSetTipsAmount, tipsRate],
    )

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid
                    item
                    xs={12}
                    md={7}
                    lg={8}
                    height={(x) => `calc(75svh - ${x.spacing(1)})`}
                >
                    <CalculatePanel
                        onChange={(amount: number) =>
                            onSetTipsAmount(new Decimal(amount), tipsType)
                        }
                        paymentDetail={paymentDetail}
                        quickButtons={quickButtons}
                        hideOperators
                        showSwitchCalculatorMode
                        disableSwitchMode={disableSwitchMode}
                        calculatorSwitchMode={tipsType}
                        onChangeCalculatorSwitchMode={onSwitchCalculator}
                        initialValue={tipsRate.toNumber()}
                        hideQuickButtons={noQuickTip}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={5}
                    lg={4}
                    height={(x) => `calc(75svh - ${x.spacing(1)})`}
                >
                    <PaymentDetail onSubmit={onSubmitPayment} />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default AddTipsSection
